export const iconFontAwesomeMedicalHealthLaptopMedical = (
	<i className="fa-solid fa-laptop-medical"></i>
);
